// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MangoV1CardDetailsMedicalCard } from './mangoV1CardDetailsMedicalCard.js';
import type { MangoV1CardDetailsPharmacyCard } from './mangoV1CardDetailsPharmacyCard.js';
import type { MangoV1CardDetailsVirtualDebitCard } from './mangoV1CardDetailsVirtualDebitCard.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class Type {
    'pharmacyCards': Array<MangoV1CardDetailsPharmacyCard>;
    'medicalCards': Array<MangoV1CardDetailsMedicalCard>;
    'virtualDebitCards': Array<MangoV1CardDetailsVirtualDebitCard>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof Type>> = [
        {
            "name":     "pharmacyCards",
            "baseName": "pharmacyCards",
            "type":     "Array<MangoV1CardDetailsPharmacyCard>"
        },
        {
            "name":     "medicalCards",
            "baseName": "medicalCards",
            "type":     "Array<MangoV1CardDetailsMedicalCard>"
        },
        {
            "name":     "virtualDebitCards",
            "baseName": "virtualDebitCards",
            "type":     "Array<MangoV1CardDetailsVirtualDebitCard>"
        },
    ];

    static getAttributeTypeMap() {
        return Type.attributeTypeMap;
    }
}
